import React from "react";
import "../styles.css";
import errorExtractor from "../utils/errorExtractor";

const ErrorSummary = (props) => {

    var errorList = [];

    errorList = errorExtractor.extract(props.errors);

    if (errorList.length > 0) {
        return (
            (errorList.map((item) => (
                <div key={item.field} className="error">{item.msg}</div>
            ))))
    }

};

export default ErrorSummary;